export default __webpack_public_path__ + "static/media/technical.b4832c89.jpg";